import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";

import navigation from "app/navigation";
import useViewportInfo from "hooks/useViewportInfo";
import AppSidebar, { COLLAPSED_SIDEBAR_WIDTH, EXPANDED_SIDEBAR_WIDTH } from "app/layout/AppSidebar";

const COLLAPSED_CONTENT_GAP = 3;
const COLLAPSED_END_GAP = 5;

function AppShell() {
  const { pathname } = useLocation();
  const { width, height } = useViewportInfo("App shell viewport");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => window.innerWidth < 2200);
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);

  const isSidebarVisible = width >= 1200 && height >= 630;

  useEffect(() => {
    setIsSidebarCollapsed(width < 2200);
    setIsHoverExpanded(false);
  }, [pathname, width]);

  const handleSidebarMouseEnter = () => {
    if (isSidebarCollapsed && !isHoverExpanded) {
      setIsSidebarCollapsed(false);
      setIsHoverExpanded(true);
    }
  };

  const handleSidebarMouseLeave = () => {
    if (isHoverExpanded) {
      setIsSidebarCollapsed(true);
      setIsHoverExpanded(false);
    }
  };

  const sidebarColumnWidth = isSidebarCollapsed
    ? COLLAPSED_SIDEBAR_WIDTH + COLLAPSED_CONTENT_GAP
    : EXPANDED_SIDEBAR_WIDTH;
  const contentPadding = isSidebarVisible && isSidebarCollapsed ? "12px" : "16px";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: isSidebarVisible
          ? `${sidebarColumnWidth}px minmax(0, 1fr)`
          : "minmax(0, 1fr)",
        width: "100%",
        minHeight: "100vh",
        paddingRight: isSidebarVisible && isSidebarCollapsed ? `${COLLAPSED_END_GAP}px` : 0,
        overflow: "hidden",
        backgroundColor: "background.default",
        transition: "grid-template-columns .25s ease, padding-right .25s ease",
      }}
    >
      {isSidebarVisible && (
        <AppSidebar
          navigation={navigation}
          collapsed={isSidebarCollapsed}
          onMouseEnter={handleSidebarMouseEnter}
          onMouseLeave={handleSidebarMouseLeave}
        />
      )}

      <Box
        component="main"
        sx={{
          minWidth: 0,
          width: "100%",
          height: "calc(100vh - 8px)",
          paddingLeft: contentPadding,
          paddingRight: contentPadding,
          paddingTop: "8px",
          paddingBottom: "4px",
          borderRadius: "12px",
          backgroundColor: "background.default",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "padding .25s ease",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default AppShell;
